<template>
    <div>
        <b-card>
            <div slot="header">
                <b-row align-v="center">
                    <b-col cols="2"	sm="3"	md="4"	lg="4"	xl="5"></b-col>
                    <b-col cols="9"	sm="7"	md="6"	lg="6"	xl="5">
                        <h4 v-if="tabindex==0">Area de Procesamiento</h4>
                        <h4 v-else-if="tabindex==1">Area de Almacen</h4>
                        <h4 v-else-if="tabindex==2">Area de Delivery</h4>
                    </b-col>
                    <b-col cols="1" sm="2"	md="2"	lg="2"	xl="2"></b-col>
                </b-row>
            </div>
            <div v-if="cargando" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Cargando...</strong>
            </div>
            <div v-else>
        <br>
        <b-container fluid>
            <b-row>
                <b-col cols="12" sm="10" md="10"	lg="10"	xl="5">
                    <b-form-group horizontal label="Filtrar por Campo" class="mb-0">
                    <b-input-group>
                        <b-form-input v-model="filter" placeholder="Ingresa tu Busqueda" />
                        <b-input-group-append>
                        <b-btn :disabled="!filter" @click="filter = ''">Limpiar</b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12" sm="2"	md="2"	lg="2"	xl="1">
                    <b-button variant="secondary" @click="listaPedidos"><i class="fa fa-sync-alt"></i> </b-button>
                </b-col>
                <br><br>
                <b-col cols="6" sm="6"	md="6"	lg="7"	xl="2">
                    <b-form-group horizontal label="Orden" class="mb-0">
                        <b-input-group>
                        <b-form-select v-model="orden" slot="append" @input="listaPedidos">
                            <option :value="'asc'">Más Antiguo</option>
                            <option :value="'desc'">Más Reciente</option>
                        </b-form-select>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="6" sm="6"	md="6"	lg="5"	xl="2">
                    <b-form-group horizontal label="Mostrar" class="mb-0">
                        <b-input-group>
                            <b-form-select v-model="limite" slot="append">
                            <option :value="10">10</option>
                                <option :value="25">25</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </b-form-select>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="6" sm="6"	md="6"	lg="7"	xl="2" v-if="tabindex==0">
                    <b-form-group horizontal label="Estado" class="mb-0">
                        <b-input-group>
                        <b-form-select v-model="selectestado" slot="append" @input="listaPedidos()">
                            <option :value="estado.id" v-for="estado in estadosu" :key="estado.id">{{ estado.label }}</option>
                        </b-form-select>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <br>
            <template>
                <b-table 
                    responsive 
                    small
                    :items="pedidos"
                    :fields="pedidos_fields"
                    :current-page="pactual"
                    :per-page="limite"
                    :filter="filter"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    @filtered="onFiltered"
                    >
                    <template slot="item" slot-scope="row">
                        {{ row.index+1 }}
                    </template>
                    <template slot="fecha" slot-scope="row">
                        {{ row.item.created_at | moment('D/M/Y hh:mm:ss A') }}
                    </template>
                    <template slot="fuente" slot-scope="row">
                        <template v-if="row.item.ordenCompra.origen==1">
                            OC
                        </template>
                    </template>
                    <template slot="numero" slot-scope="row">
                        {{ row.item.serie }}-{{ row.item.numero }}
                    </template>
                    <template slot="receptor" slot-scope="row">
                        <template v-if="row.item.ordenCompra.receptor">
                            {{row.item.ordenCompra.receptor.nro}} - {{row.item.ordenCompra.receptor.razonSocial}}
                        </template>
                    </template>
                    <template slot="cantidad" slot-scope="row">
                        {{ row.item.ordenCompra.cantidaditems }}
                    </template>
                    <template v-if="row.item.ordenCompra.credito" slot="condicion" slot-scope="row">
                        {{ row.item.ordenCompra.credito.nombre }}
                    </template>
                    <template slot="importe" slot-scope="row">
                        <div class="text-right">
                            <template v-if="row.item.ordenCompra.moneda.codigo=='PEN'">S/</template>
                            <template v-else-if="row.item.ordenCompra.moneda.codigo=='USD'">$</template>
                            <template v-else>{{ row.item.ordenCompra.moneda.simbolo }}</template>
                            {{ row.item.ordenCompra.totales.importeTotal.toFixed(2) }}
                        </div>
                    </template>
                    <template slot="state" slot-scope="row">
                        <b-badge v-if="row.item.estado=='0' || row.item.estado=='4' || row.item.estado=='8'" variant="info"><i class="fa fa-hourglass-half"></i> Pendiente</b-badge>
                        <b-badge v-else-if="row.item.estado=='1' || row.item.estado=='5'" variant="warning"><i class="fa fa-exclamation-triangle"></i> Observado</b-badge>
                        <b-badge v-else-if="row.item.estado=='2' || row.item.estado=='6'" variant="danger"><i class="fa fa-times-circle"></i> Rechazado</b-badge>
                        <b-badge v-else-if="row.item.estado=='3'" variant="success"><i class="fa fa-share-square"></i> Almacen</b-badge>
                        <b-badge v-else-if="row.item.estado=='7'" variant="success"><i class="fa fa-share-square"></i> Delivery</b-badge>
                        <b-badge v-else-if="row.item.estado=='9'" variant="primary"><i class="fa fa-truck"></i> Por Enviar</b-badge>
                        <b-badge v-else-if="row.item.estado=='10'" variant="success"><i class="fa fa-check"></i> Enviado</b-badge>
                        <b-badge v-else-if="row.item.estado=='11'" variant="success"><i class="fa fa-check-double"></i> Entregado</b-badge>
                        <b-badge v-else-if="row.item.estado=='12'" variant="warning"><i class="fa fa-exclamation-triangle"></i> No Aceptado</b-badge>
                        <b-badge v-else-if="row.item.estado=='13'" variant="danger"><i class="fa fa-times-circle"></i> No Encontrado</b-badge>
                    </template>
                    <template slot="acciones" slot-scope="row">
                        <b-button-group>
                            <button size="sm" @click="row.toggleDetails" type="button" class="btn" title="Mas opciones">
                                <template v-if="!row.item.mostrardetalles">
                                    <i class="fa fa-plus"></i>
                                </template>
                                <template v-else>
                                    <i class="fa fa-minus"></i>
                                </template>
                            </button>
                            <b-button v-if="row.item.estados.length > 0" class="pl-2 pr-2" @click="sethitos(row.item)" v-b-modal.timelinehistory variant="secondary">
                                <i title="Linea de tiempo" class="fa fa-route"></i>
                            </b-button>
                            <b-button v-else class="pl-2 pr-2" disabled variant="secondary">
                                <i title="Linea de tiempo" class="fa fa-route"></i>
                            </b-button>
                            <b-button class="pl-2 pr-2" :disabled="row.item.observaciones==null" v-b-modal.checkobservacionbuton variant="primary" @click="setEstado(row.item)">
                                <i title="Observaciones" class="fa fa-eye"></i>
                            </b-button>
                            <b-button v-b-modal.cambiarestado variant="warning" size="sm" @click="setEstado(row.item)"><i title="Cambiar modulo" class="fa fa-1x fa-cogs"></i></b-button>
                        </b-button-group>
                    </template>
                    <template v-slot:row-details="row">
                        <b-card class="tamanioletra">
                            <b-table
                            striped
                            hover
                            :items="row.item.ordenCompra.items"
                            :fields="listaitems_fields"
                            :busy="row.item.loading"
                            >
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Cargando...</strong>
                            </div>
                            <template slot="index" slot-scope="row">{{ row.index+1 }}</template>
                            <template slot="cantidad" slot-scope="row">
                                <div class="text-right">{{ Number.parseFloat(row.item.cantidad).toFixed(2) }}</div>
                            </template>
                            <template slot="precioVentaUnitario" slot-scope="row">
                                <div class="text-right">
                                <template v-if="row.item.moneda=='PEN'">S/</template>
                                <template v-else-if="row.item.moneda=='USD'">$</template>
                                <template v-else>{{ row.item.moneda }}</template>
                                <template
                                    v-if="row.item.precioVentaUnitario"
                                >{{ Number.parseFloat(row.item.precioVentaUnitario).toFixed(2) }}</template>
                                </div>
                            </template>
                            <template slot="descuento" slot-scope="row">
                                <div class="text-right">
                                <template v-if="row.item.moneda=='PEN'">S/</template>
                                <template v-else-if="row.item.moneda=='USD'">$</template>
                                <template v-else>{{ row.item.moneda }}</template>
                                {{ Number.parseFloat(row.item.descuento).toFixed(2) }}
                                </div>
                            </template>
                            <template slot="valorVenta" slot-scope="row">
                                <div class="text-right">
                                <template v-if="row.item.moneda=='PEN'">S/</template>
                                <template v-else-if="row.item.moneda=='USD'">$</template>
                                <template v-else>{{ row.item.moneda }}</template>
                                <template
                                    v-if="row.item.valorVenta"
                                >{{ Number.parseFloat(row.item.valorVenta*($store.state.igv == 18 ? 1.18 : 1.105)).toFixed(2) }}</template>
                                </div>
                            </template>
                            </b-table>
                        </b-card>
                    </template>
                </b-table>
            </template>
            <b-modal id="cambiarestado" title="Cambiar estado" v-model="changeEstado">
                <b-row>
                    <b-col cols="10" sm="10"	md="4"	lg="8"	xl="3">
                        Estado: 
                    </b-col>
                    <b-col cols="10" sm="10"	md="4"	lg="8"	xl="3">
                        <b>{{ estadolabel }}</b>
                    </b-col>
                    <b-col cols="2" sm="2"	md="4"	lg="4"	xl="6">
                        <b-dropdown variant="link" no-caret>
                            <template v-slot:button-content>
                            <button class="btn btn-light m-0 p-0">
                                <i class="fa fa-ellipsis-v"></i>
                            </button>
                            </template>
                                <template v-if="tabindex==0">
                                    <b-dropdown-item @click="preEstado(0)">                  
                                        <i class="fa fa-hourglass-half mr-2 text-info"></i> Pendiente
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="preEstado(1)">                  
                                        <i class="fa fa-exclamation-triangle mr-2 text-warning"></i> Observar
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="preEstado(2)">                  
                                        <i class="fa fa-1x fa-times-circle mr-2 text-danger"></i> Rechazar
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="preEstado(3)">                  
                                        <i class="fa fa-share-square mr-2 text-success"></i> Almacen
                                    </b-dropdown-item>
                                </template>
                                <template v-if="tabindex==1">
                                    <b-dropdown-item @click="preEstado(4)">                  
                                        <i class="fa fa-hourglass-half mr-2 text-info"></i> Pendiente
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="preEstado(5)">                  
                                        <i class="fa fa-exclamation-triangle mr-2 text-warning"></i> Observado
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="preEstado(6)">                  
                                        <i class="fa fa-1x fa-times-circle mr-2 text-danger"></i> Rechazar
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="preEstado(7)">                  
                                        <i class="fa fa-share-square mr-2 text-success"></i> Delivery
                                    </b-dropdown-item>
                                </template>
                                <template v-if="tabindex==2">
                                    <b-dropdown-item @click="preEstado(8)">                  
                                        <i class="fa fa-hourglass-half mr-2 text-info"></i> Pendiente
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="preEstado(9)">                  
                                        <i class="fa fa-truck mr-2 text-primary"></i> Listo para enviar
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="preEstado(10)">                  
                                        <i class="fa fa-check mr-2 text-success"></i> Enviado
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="preEstado(11)">                  
                                        <i class="fa fa-check-double mr-2 text-success"></i> Entregado
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="preEstado(12)">                  
                                        <i class="fa fa-exclamation-triangle mr-2 text-warning"></i> No aceptado
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="preEstado(13)">                  
                                        <i class="fa fa-times-circle mr-2 text-danger"></i> No encontrado
                                    </b-dropdown-item>
                                </template>
                        </b-dropdown>
                    </b-col>
                </b-row><br>
                <b-row>
                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                        <b-form-textarea
                            v-model="observaciones"
                            placeholder="Observaciones..."
                            rows="3"
                            max-rows="6"
                        ></b-form-textarea>
                    </b-col>
                </b-row>
                <div slot="modal-footer" class="w-100">
                    <b-btn
                        v-if="!sendingestado"
                        @click="sendEstado()"
                        size="sm"
                        class="float-right"
                        variant="primary"
                    >Enviar</b-btn>
                    <b-btn
                        v-else
                        size="sm"
                        class="float-right"
                        variant="secondary"
                    >Enviando <i class="fa fa-spin fa-spinner"></i></b-btn>
                </div>
            </b-modal>
            <b-modal id="timelinehistory" title="Historico del pedido" size="xl" v-model="timelinehistory">
                <div>
                    <timeline :hitos="listaHitos"></timeline>
                </div>
                <div slot="modal-footer" class="w-100">
                    <b-btn
                    @click="closetimeline()"
                    size="sm"
                    class="float-right"
                    variant="primary"
                    >Ok</b-btn>
                </div>
            </b-modal>
            <b-modal id="checkobservacionbuton" title="Observaciones" v-model="checkobservacion">
                <div role="group">
                    <div v-if="spinoff">
                    <div class="row">
                        <div class="col-md-12 text-center">
                        <h3>
                            Cargando
                            <i class="fa fa-spin fa-spinner"></i>
                        </h3>
                        </div>
                    </div>
                    </div>
                    <div v-else>
                    <div class="row">
                        <div class="col-md-12 text-center">
                        <h6>{{ packageShipping.observaciones }}</h6>
                        </div>
                    </div>
                    </div>
                </div>
                <div slot="modal-footer" class="w-100">
                    <b-btn
                    @click="closeobs()"
                    size="sm"
                    class="float-right"
                    variant="primary"
                    >Ok</b-btn>
                </div>
            </b-modal>
            <div class="row">
                <div class="col-md-6">
                    <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                </div>
                <div class="col-md-6">
                    <div class="float-right">
                        <b-pagination size="sm" :total-rows="total" v-model="currentPage" @input="listaPedidos" :per-page="limite"></b-pagination>
                    </div>            
                </div>
            </div>
        </b-container>
        </div>
        </b-card>
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import axios from 'axios'
import Timeline from '@/components/comunes/Timeline'
    export default {
        name: '',
        components: {
            Timeline
        },
        props: ['tab'],
        data: () => {
            return {
                spinoff: false,
                tabindex: 0,
                checkobservacion: false,
                sendingestado: false,
                estadoid: '',
                estadolabel: '',
                observaciones: '',
                estados: [
                    {id: 0, label: 'Pendiente'},
                    {id: 1, label: 'Observado'},
                    {id: 2, label: 'Rechazado'},
                    {id: 3, label: 'Almacen'},
                    {id: 4, label: 'Pendiente'},
                    {id: 5, label: 'Observado'},
                    {id: 6, label: 'Rechazado'},
                    {id: 7, label: 'Delivery'},
                    {id: 8, label: 'Pendiente'},
                    {id: 9, label: 'Listo para enviar'},
                    {id: 10, label: 'Enviado'},
                    {id: 11, label: 'Entregado'},
                    {id: 12, label: 'No aceptado'},
                    {id: 13, label: 'No encontrado'}
                ],
                selectestado: 0,
                estadosu: [
                    {id: 0, label: 'Pendiente'},
                    {id: 2, label: 'Observado'},
                    {id: 3, label: 'Rechazado'}
                ],
                packageShipping: {},
                cargando: false,
                pedidos: [],
                pedidos_fields: [
                    {key: 'item', label: 'Item', sorteable: true},
                    {key: 'fecha', label: 'Fecha', sorteable: true},
                    {key: 'fuente', label: 'Fuente', sorteable: true},
                    {key: 'numero', label: 'Numero', sorteable: true},
                    {key: 'receptor', label: 'Emisor', sorteable: true},
                    {key: 'cantidad', label: 'Cantidad', sorteable: true},
                    {key: 'condicion', label: 'Condicion', sorteable: true},
                    {key: 'importe', label: 'Importe', sorteable: true},
                    {key: 'state', label: 'Estado', sorteable: true},
                    {key: 'acciones', label: 'Acciones', sorteable: true},
                ],
                listaitems_fields: [
                    { key: "index" },
                    { key: "codigoProducto", label: "Codigo", sorteable: true },
                    { key: "unidadMedidaCantidad", label: "Unidad", sorteable: true },
                    { key: "descripcion", label: "Descripción", sorteable: true },
                    { key: "cantidad", label: "Cantidad", sorteable: true },
                    { key: "precioVentaUnitario", label: "Precio Unit", sorteable: true },
                    { key: "descuento", label: "Descuento", sorteable: true },
                    { key: "valorVenta", label: "Precio Total", sorteable: true }
                ],
                pactual: 1,
                limite: 10,
                orden: 'desc',
                sortBy: null,
                sortDesc: false,
                sortDirection: 'asc',
                currentPage: 1,
                totalRows: null,
                filter: null,
                total: 0.00,
                desde: 0.00,
                hasta: 0.00,
                changeEstado: false,
                timelinehistory: false,
                listaHitos: []
            }
        },
        mounted(){
            this.checktab(),
            this.listaPedidos()
        },
        methods: {
            sethitos: function (data) {
                let estados = data.estados
                let hito = {}
                this.listaHitos = []
                estados.forEach(element => {
                    hito.creacion = this.$moment(element.created_at).format('YYYY-MM-DD HH:mm:ss')
                    hito.departamento = element.departamento,
                    hito.estado = this.preEstado(element.estado)
                    this.listaHitos.push(hito)
                    hito = {}
                });
            },
            closetimeline: function () {
                this.timelinehistory = false
            },
            closeobs: function () {
                this.checkobservacion = false
            },
            checktab: function () {
                console.log('El tab enviado es: '+this.tab),
                this.tabindex = this.tab
            },
            setEstado: function (data) {
                this.packageShipping = data
                this.preEstado(data.estado)
            },
            preEstado: function (tipo) {
                let idestado = ''
                let labelestado = ''
                for(let i=0; i<this.estados.length; i++){
                    if(this.estados[i].id == tipo){
                        idestado = this.estados[i].id
                        labelestado = this.estados[i].label
                    }   
                }
                this.estadoid = idestado,
                this.estadolabel = labelestado
                return this.estadolabel
            },
            sendEstado: function () {
                let departamento = this.selectDepartamento()
                this.sendingestado = true
                axios
                .post(process.env.VUE_APP_API_URL + 'ordencompra/estado',{
                    token: this.$store.getters.userToken,
                    id: this.packageShipping.idOrdenCompra,
                    estado: this.estadoid,
                    departamento: departamento,
                    observaciones: this.observaciones
                })
                .then(response => {
                    this.$snotify.success(response.data.msg,'Exito'),
                    this.sendingestado = false,
                    this.changeEstado = false,
                    this.observaciones = '',
                    this.changeTab(this.estadoid)
                })
                .catch(error => {
                    this.sendingestado = false,
                    this.cargando = false,
                    this.changeEstado = false
                })
            },
            onFiltered (filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            listaPedidos: function () {
                let departamento = this.selectDepartamento()
                this.cargando = true
                axios
                .post(process.env.VUE_APP_API_URL + 'ordencompra/listar/recibido',{
                    token: this.$store.getters.userToken,
                    page: this.currentPage,
                    limit: this.limite,
                    order: this.orden,
                    departamento: departamento
                })
                .then(response => (
                    this.cargando = false,
                    this.pedidos = response.data.data,
                    this.total = response.data.total,
                    this.desde = response.data.from,
                    this.hasta = response.data.to
                ))
                .catch(error => {
                    this.cargando = false
                })
            },
            selectDepartamento: function () {
                let departamento = ''
                if(this.tabindex == 0){
                    departamento = 'PROCESAMIENTO'
                }else if (this.tabindex == 1) {
                    departamento = 'ALMACEN'
                }else if (this.tabindex == 2) {
                    departamento = 'DELIVERY'
                }
                return departamento
            },
            changeTab: function (estado){
                switch(estado){
                    case 3:
                        this.$emit("tabindex", 1);
                    break;
                    case 7: 
                        this.$emit("tabindex", 2);
                    break;
                }
                this.listaPedidos()
            },
        }  
    }
</script>

<style>
    .tamanioletra {
        font-size: 13px;
        font-family: "Roboto Mono";
        margin-left: 3%;
        padding: 0px;
    }
</style>
<style>
@import url("https://fonts.googleapis.com/css?family=Roboto+Mono&display=swap");
</style>